import './App.css';
import { BrowserRouter as Router, Routes, Route, } from 'react-router';
import EmailCheck from './pages/EmailCheck';
import FeedbackForm from './pages/FeedbackForm';
import FormEnd from './pages/FormEnd';
function App() {
  return (
    <Router>
      <div className="App">
        <img src='/EditorialWorkshop-2025.webp'  className='header-logo'/>
        
        <Routes>
          <Route path="/" element={<EmailCheck />} />
          <Route path="*" element={<EmailCheck />} />
          <Route path="/feedback" element={<FeedbackForm />} />
          <Route path="/thankyou" element={<FormEnd />} />
        </Routes>
      </div>
    </Router>
    
  );
}

export default App;
